import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GroupListComponent } from './components/group-list/group-list.component';
import { NewGroupComponent } from './components/new-group/new-group.component';
import { ChooseSeatsComponent } from './components/choose-seats/choose-seats.component';
import { SharedModule } from 'shared/shared.module';
import { AuthGuard } from 'app/shared/services/Guards/Auth-Guard/auth-guard.service';
import { ChooseSeasonComponent } from './components/choose-season/choose-season.component';
import { GroupService } from 'shared/services/SS-Groups/groups.service';
import { CurrencyMaskModule } from 'ng2-currency-mask';
import { GroupsGuard } from 'shared/services/Guards/groups-guard';
import { SeatMapComponent } from './components/choose-seats/seat-map/seat-map.component';
import { LeaderChargeCardComponent } from 'shared/reusable/leader-charge-card/leader-charge-card.component';
import { MatDialogModule } from '@angular/material';
import { WaitingRoomComponent } from './components/waiting-room/waiting-room.component';
import { MdTabNavigationComponent } from '../md-tab-navigation/md-tab-navigation.component';
import { GetReadyComponent } from './components/get-ready/get-ready.component';
import { AngularDateTimePickerModule } from 'angular2-datetimepicker';
import { TicketDraftComponent } from 'shared/reusable/ticket-draft/ticket-draft.component';
import { InviteFriendsModalComponent } from './components/waiting-room/invite-friends-modal/invite-friends-modal.component';
import { ChooseTeamComponent } from './components/choose-team/choose-team.component';
import { ConnectTeamAccountComponent } from 'shared/reusable/connect-team-account/connect-team-account.component';
import { ChooseUploadPlanComponent } from 'shared/reusable/choose-upload-plan/choose-upload-plan.component';
import { InviteCodeModalComponent } from './components/new-group/invite-code-modal/invite-code-modal.component';
import { ChargeCardComponent } from 'shared/reusable/charge-card/charge-card.component';
import { UserProfileComponent } from 'shared/reusable/user-profile/user-profile.component';
import { TeamAccountComponent } from 'shared/reusable/team-account/team-account.component';
import { SearchGamePipe } from 'shared/pipes/searchGame/searchGame.pipe';
import { PublicGroupComponent } from './components/public-group/public-group.component';
import { ChooseSeatSelectionComponent } from 'shared/reusable/choose-seat-selection/choose-seat-selection.component';
import { ViewDetailComponent } from 'shared/reusable/view-detail/view-detail.component';
import { StipeConnectComponent } from 'shared/reusable/stipe-connect/stipe-connect.component';
import { PublicGroupsComponent } from './../widget/public-groups/public-groups.component';
import { ViewDetailsComponent } from './../widget/view-details/view-details.component';
import { LoginModelComponent } from './../widget/view-details/login-model/login-model.component';
import { ConnectTeamModalComponent } from 'shared/reusable/connect-team-modal/connect-team-modal.component';
import { SeatViewModal } from 'shared/reusable/seat-view-modal/seat-view-modal.component';
import { ChooseTeamPublicComponent } from 'app/modules/group/components/choose-team-public-groups/choose-team-public.component';
import { InputPromoModalComponent } from 'shared/reusable/input-promo-modal/input-promo-modal.component';
import { SubscriptionHomeComponent } from 'app/modules/group/components/subscription-home/subscription-home.component';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    CurrencyMaskModule,
    MatDialogModule,
    AngularDateTimePickerModule,
    RouterModule.forChild([
      {
        path: 'new-group',
        component: MdTabNavigationComponent,
        canActivate: [AuthGuard],
        children: [
          { path: '', component: NewGroupComponent, canActivate: [AuthGuard] },
          { path: 'choose-season', component: ChooseSeasonComponent, canActivate: [AuthGuard] },
          { path: 'seat-selection', component: ChooseSeatSelectionComponent, canActivate: [AuthGuard] },
          { path: 'choose-team', component: ChooseTeamComponent, canActivate: [AuthGuard] },
          { path: 'choose-seats', component: ChooseSeatsComponent, canActivate: [AuthGuard] },
          { path: 'leader-charge-card', component: LeaderChargeCardComponent, canActivate: [AuthGuard] },
          { path: 'choose-team/connect-account', component: ConnectTeamAccountComponent, canActivate: [AuthGuard] },
          { path: 'choose-team/connect-account/upload-plan', component: ChooseUploadPlanComponent, canActivate: [AuthGuard] },
          { path: 'choose-team/upload-plan', component: ChooseUploadPlanComponent, canActivate: [AuthGuard] },
          { path: 'charge-card', component: ChargeCardComponent, canActivate: [AuthGuard] }]
      },
      {
        path: 'tmcallback',
        component: MdTabNavigationComponent,
        canActivate: [AuthGuard],
        children: [
          { path: 'upload', component: NewGroupComponent, canActivate: [AuthGuard] },
        ]
      },
      {
        path: 'groups',
        component: MdTabNavigationComponent,
        canActivate: [AuthGuard],
        children: [
          { path: '', component: GroupListComponent, canActivate: [AuthGuard] },
          { path: 'waiting-room', component: WaitingRoomComponent, canActivate: [AuthGuard, GroupsGuard] },
          { path: 'get-ready', component: GetReadyComponent, canActivate: [AuthGuard, GroupsGuard] },
          { path: 'get-reday/ticket-draft', component: TicketDraftComponent, canActivate: [AuthGuard, GroupsGuard] },
          { path: 'waiting-room/get-ready', component: GetReadyComponent, canActivate: [AuthGuard, GroupsGuard] }
        ]
      },
      {
        path: 'profile',
        component: MdTabNavigationComponent,
        canActivate: [AuthGuard],
        children: [
          { path: '', component: UserProfileComponent, canActivate: [AuthGuard] },
        ]
      },
      {
        path: 'team',
        component: MdTabNavigationComponent,
        canActivate: [AuthGuard],
        children: [
          { path: '', component: TeamAccountComponent, canActivate: [AuthGuard] },
        ]
      },
      {
        path: 'stripe-redirect',
        canActivate: [AuthGuard],
        children: [
          { path: '', component: StipeConnectComponent, canActivate: [AuthGuard] },
        ]
      },
      { path: 'widget/public-groups/:teamId', component: PublicGroupsComponent },
      { path: 'widget/view-details/:groupId', component: ViewDetailsComponent },
      {
        path: 'new-group/public-groups', component: MdTabNavigationComponent,
        children: [
          { path: '', component: PublicGroupComponent },
          { path: 'view-detail', component: ViewDetailComponent },
          { path: 'choose-team', component: ChooseTeamPublicComponent, canActivate: [AuthGuard] }
        ]
      },
      {
        path: 'subscriptions', 
        component: MdTabNavigationComponent,
        children: [
          { path: '', component: SubscriptionHomeComponent },
        ]
      }
    ])
  ],
  providers: [
    GroupService,
    SearchGamePipe
  ],
  entryComponents: [
    SeatMapComponent,
    InviteFriendsModalComponent,
    InviteCodeModalComponent,
    ConnectTeamModalComponent,
    InputPromoModalComponent,
    SeatViewModal,
    LoginModelComponent
  ],
  declarations: [
    ChooseSeatsComponent,
    GroupListComponent,
    NewGroupComponent,
    ChooseSeasonComponent,
    SeatMapComponent,
    WaitingRoomComponent,
    GetReadyComponent,
    InviteFriendsModalComponent,
    ChooseTeamComponent,
    ChooseTeamPublicComponent,
    InviteCodeModalComponent,
    ConnectTeamModalComponent,
    InputPromoModalComponent,
    SeatViewModal,
    PublicGroupComponent,
    PublicGroupsComponent,
    ViewDetailsComponent,
    LoginModelComponent
  ],
  bootstrap: []
})
export class GroupModule { }



// WEBPACK FOOTER //
// ./src/app/modules/group/group.module.ts